jQuery(document).ready(function($){
    $('#check-terms').change(function() {
        if ($(this).is(":checked")) {
            $('.error-msg').css('visibility','hidden');
            $('#mmol-btn, #mg-btn').removeAttr('disabled');
            $('.pre-disabled-btn').hide();         
        } else {
            $('#mmol-btn, #mg-btn').attr('disabled','disabled');
            $('.pre-disabled-btn').show();
        }          
    });
    $("input[name='units']:radio").change(function(){
        if($(this).val() == 'mg')
        {
          $('#mmol-btn').addClass('d-none');  
          $('#mg-btn').removeClass('d-none');
        }
        else if($(this).val() == 'mmol')
        {
          $('#mg-btn').addClass('d-none');  
          $('#mmol-btn').removeClass('d-none');
        }      
    })
    var videoSrc; 
    $('.btn-video').click(function() {
        videoSrc = $(this).data( "src" );
    });
    $(".pre-disabled-btn").click(function (evt) {
        $('.error-msg').css('visibility','visible');
    });
}(window.jQuery));